import { ConfirmModal } from '../../../commons/components/ConfirmModal';
import { useUnpauseMutation } from '../../hooks/useUnpauseMutation';
import { useState } from 'react';

export const UnpauseConfirmationModal = () => {
  const [resumed, setResumed] = useState(false);
  const { mutate: unpause, isLoading: isUnpausing } = useUnpauseMutation({
    onSuccess: () => setResumed(true),
  });
  return !resumed ? (
    <ConfirmModal
      key="asking-modal"
      title="Would you like to resume your plan now?"
      footer={{
        type: 'show',
        cancelButton: { label: 'Cancel', disabled: isUnpausing, onClick: () => {} },
        applyButton: {
          label: 'Resume plan',
          disabled: isUnpausing,
          onClick: () => {
            unpause();
          },
        },
      }}
    />
  ) : (
    <ConfirmModal
      key="resumed-modal"
      title="Your request to resume the plan has been received"
      footer={{ type: 'show', cancelButton: { label: 'Close', onClick: () => {} } }}
    >
      Allow one to two business days for the request to be processed.
    </ConfirmModal>
  );
};
